import React from "react";
import { Button } from "@chakra-ui/react";
import { Modal } from "components";

interface ClearProps {
  clearHandler: { clear(): void; isLoading: boolean };
}

const Clear: React.FC<ClearProps> = ({ clearHandler }) => {
  return (
    <Button
      colorScheme="minor"
      isLoading={clearHandler.isLoading}
      onClick={() => {
        Modal.instance.open({
          title: "Clear QuickDraw",
          description:
            "Are you sure you want to clear? All the changes will be deleted.",
          okText: "Clear",
          onOk() {
            clearHandler.clear();
          }
        });
      }}
    >
      Clear All
    </Button>
  );
};

export default Clear;
